import React from 'react';
import type { Control } from 'react-hook-form';
import { FieldRow } from '@innovixx/react-form-fields';
import styles from './styles.module.scss';
import { AppTextInput } from '../../../formFields';
import { Button } from '../../../Button';

interface Props {
  control: Control;
  handlePrevious: () => void;
  loading?: boolean;
}

export const LeadDetailsForm: React.FC<Props> = ({ control, handlePrevious, loading }) => (
  <div>
    <legend className={styles.label}>Please enter your contact details</legend>
    <FieldRow>
      <AppTextInput
        control={control}
        name="firstName"
        label="First Name"
        required
      />
      <AppTextInput
        control={control}
        name="lastName"
        label="Last Name"
        required
      />
    </FieldRow>
    <FieldRow>
      <AppTextInput
        control={control}
        name="email"
        label="Email"
        required
        rules={{
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Invalid email address',
          },
        }}
      />
      <AppTextInput
        control={control}
        name="phone"
        label="Phone"
        required
        rules={{
          pattern: {
            value: /^\+?[0-9]*$/,
            message: 'Invalid phone number',
          },
        }}
      />
    </FieldRow>
    <div className={styles.buttonsContainer}>
      <Button
        onClick={handlePrevious}
        title="Back"
        htmlType="submit"
        type='secondary'
      >
        Back
      </Button>
      <Button
        title="Submit"
        htmlType="submit"
        loading={loading}
      >
        Submit
      </Button>
    </div>
  </div>
);
